import { useContext } from 'react';
import { CreateTransactionsContext, CreateTransactionsValues } from '../contexts/CreateTransactionsContext';
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, Autocomplete, Switch, FormControlLabel, Stack, useMediaQuery, CircularProgress, useTheme } from '@mui/material';

export const CreateTransactionsTopForms = () => {
  const { transactionTypesToShow,
    handleTypeChange,
    handleSearchTermChange,
    handleItemSelect,
    dropDownItems,
    transactionType,
    createDate,
    handleCreateDateChange,
    value,
    searchTerm,
    itemsToCreate,
    isItemsLoading,
    isDisableActions,
    handleRecentActivity,
    hasRecentActivity,
    isLoadingTypes,
    t } = useContext(CreateTransactionsContext) as CreateTransactionsValues;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid item
        md={6}
        xs={12}>
        <FormControl fullWidth
          size='small'>
          <InputLabel id="transaction-types-label">{t('transactionTypes')}</InputLabel>
          <Select
            labelId="transaction-types-label"
            id="transaction-types-select"
            disabled={isDisableActions}
            value={transactionType?.id ?? ''}
            label={t('transactionTypes')}
            onChange={handleTypeChange}
          >
            {transactionTypesToShow().map((type) => {
              return <MenuItem key={type.id}
                value={type.id}>{type.type}</MenuItem>;
            })}
            {isLoadingTypes && (
              <MenuItem value="">
                <CircularProgress size={20}
                  sx={{ mr: 1 }} />
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid><Grid item
        md={6}
        xs={12}>
        <FormControl fullWidth
          size='small'>
          <TextField
            id="datetime-input"
            label={t('Date')}
            type='datetime-local'
            size='small'
            variant="outlined"
            disabled={isDisableActions}
            value={new Date(createDate.getTime() - createDate.getTimezoneOffset() * 60000).toISOString().slice(0, 16)} // Adjust for timezone offset
            onChange={handleCreateDateChange}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: new Date().toISOString().slice(0, 16),
            }}
          />
        </FormControl>
      </Grid>
      <Grid item
        xs={12}>
        <Stack direction={isMobile ? 'column' : 'row'}
          sx={{ width: '100%' }}
          spacing={4}
          alignItems={isMobile ? 'start' : 'center'}>
          <Autocomplete fullWidth={isMobile}
            size="small"
            loading={isItemsLoading}
            value={value}
            disabled={transactionType == undefined || isDisableActions}
            onChange={(event, newValue: string | null | undefined) => {
              if (newValue) {
                handleItemSelect(newValue);
              }
            }}
            inputValue={searchTerm}
            onInputChange={(event, newInputValue) => {
              handleSearchTermChange(newInputValue);
            }}
            isOptionEqualToValue={() => true}
            options={dropDownItems}
            filterOptions={(x) => x}
            getOptionDisabled={(option) =>
              itemsToCreate.some(
                (x) => x.itemNumber + ' - ' + x.description === option,
              )
            }
            renderInput={(params) => (
              <TextField {...params}
                label={t('itemNumberOrDescription')} />
            )}
            sx={{ flexGrow: 1 }} // makes Autocomplete take all available space
          />

          <FormControlLabel
            control={
              <Switch checked={hasRecentActivity}
                onChange={handleRecentActivity} />
            }
            label={t('hasRecentActivity')}
            labelPlacement="start"
            sx={{ whiteSpace: isMobile ? 'normal' : 'nowrap' }} // optional, keeps label on one line
          />
        </Stack>
      </Grid>
    </>
  );
};

